import { render, staticRenderFns } from "./DashboardData.vue?vue&type=template&id=6d8b7bf9&scoped=true&"
import script from "./DashboardData.vue?vue&type=script&lang=js&"
export * from "./DashboardData.vue?vue&type=script&lang=js&"
import style0 from "./DashboardData.vue?vue&type=style&index=0&id=6d8b7bf9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b7bf9",
  null
  
)

export default component.exports